import React from 'react';
import { color } from '@surfline/quiver-themes';

const SurfIcon = () => (
  <svg width="40" height="40" viewBox="0 0 40 40">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g fill={color('dark-blue', 10)}>
        <path d="M15.8717658,38.8333217 C9.07820218,37.6158909 3.55316683,32.8452611 1.38095238,26.5616473 C1.44886888,24.3792493 1.59139844,22.9266287 1.80854107,22.2037856 C4.74641353,12.4239421 21.2245579,3.30773945 27.2794274,14.4512548 C27.3524541,14.5856548 21.6825906,14.0737827 20.1631002,16.727356 C18.4746013,19.6760783 20.569627,26.0667319 34.7207766,26.0667319 L37.3809524,26.0667319 C35.3330467,32.5938888 29.697813,37.5841254 22.7269897,38.8333217 L15.8717658,38.8333217 Z" />
        <path
          d="M20,39.7619048 C9.08580137,39.7619048 0.238095238,30.9141986 0.238095238,20 C0.238095238,9.08580137 9.08580137,0.238095238 20,0.238095238 C30.9141986,0.238095238 39.7619048,9.08580137 39.7619048,20 C39.7619048,30.9141986 30.9141986,39.7619048 20,39.7619048 Z M20,38.3333333 C30.1252204,38.3333333 38.3333333,30.1252204 38.3333333,20 C38.3333333,9.87477959 30.1252204,1.66666667 20,1.66666667 C9.87477959,1.66666667 1.66666667,9.87477959 1.66666667,20 C1.66666667,30.1252204 9.87477959,38.3333333 20,38.3333333 Z"
          fillRule="nonzero"
        />
      </g>
    </g>
  </svg>
);

export default SurfIcon;
